//herohead de la pagina principal
const Herohead = () => {
  return (
    <div className="h-[90vh] flex items-center bg-transparent ">
      
      <div className="px-6 mx-auto mt-0 mb-10 max-w-7xl sm:mt-4 sm:mb-16">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight dark:text-gray-200 text-neutral-950 sm:text-5xl md:text-6xl font-title">
            <span className="block">Hi, this is Dravvt&apos;s portfolio</span>
            <span className="block pt-2">where creativity meets code</span>
          </h1>
          <p className="max-w-md mx-auto mt-3 text-base dark:text-gray-300 text-neutral-700 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            Here, I&apos;m showcasing projects in C++, Python, and general programming, with a focus on the intersection of art and technology. Take a stroll through my blog!
          </p>
          <div className="max-w-md mx-auto mt-5 sm:flex sm:justify-center md:mt-8">
            <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
              <a
                href="/projects" // Asegúrate de que esta ruta esté correcta en WordPress
                className="block shadow-lg w-full px-8 py-3 text-base font-medium text-gray-200 hover:text-gray-100 dark:bg-yellow-600 bg-blue-500 hover:bg-blue-700 hover:backdrop-blur-xl backdrop-blur-lg rounded-md md:py-4 md:text-lg md:px-10"
              >
                See Projects
              </a>        
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Herohead;

